import { Reducer, combineReducers } from 'redux';
import { Dealer } from '../../Models/Dealer';
import { ILookupItem } from '../../Models/LookupItem';
import { IPerformanceCategory } from '../../Models/PerformanceCategory';
import { IPerformanceItem } from '../../Models/PerformanceItem';
import {
  LibraryAction,
  LOAD_LIBRARY_SUCCESS,
} from './actions';

export interface LibraryState {
  performanceItems: IPerformanceItem[];
  performanceItemCategories: IPerformanceCategory[];
  performanceReportStatuses: ILookupItem[];
  dpgClients: Dealer[];
  clientBusinessTypes: ILookupItem[];
  roles: ILookupItem[];
  businessTypes: ILookupItem[];
  usedClientIds: string[];
}
const INITIAL_STATE: LibraryState = {
  performanceItems: [],
  performanceItemCategories: [],
  performanceReportStatuses: [],
  dpgClients: [],
  roles: [],
  businessTypes: [],
  usedClientIds: [],
  clientBusinessTypes: [],
}
const performanceItemsReducer = (state: IPerformanceItem[] = INITIAL_STATE.performanceItems, action: LibraryAction): IPerformanceItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.performanceItems;
    default:
      return state;
  }
}
const performanceItemCategoriesReducer = (state: ILookupItem[] = INITIAL_STATE.performanceItemCategories, action: LibraryAction): ILookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.performanceItemCategories;
    default:
      return state;
  }
}
const performanceReportStatusesReducer = (state: ILookupItem[] = INITIAL_STATE.performanceReportStatuses, action: LibraryAction): ILookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.performanceReportStatuses;
    default:
      return state;
  }
}
const dpgClientsReducer = (state: Dealer[] = INITIAL_STATE.dpgClients, action: LibraryAction): Dealer[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.dpgClients;
    default:
      return state;
  }
}
const rolesReducer = (state: ILookupItem[] = INITIAL_STATE.roles, action: LibraryAction): ILookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.roles;
    default:
      return state;
  }
}
const businessTypesReducer = (state: ILookupItem[] = INITIAL_STATE.businessTypes, action: LibraryAction): ILookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.businessTypes;
    default:
      return state;
  }
}
const usedClientIdsReducer = (state: string[] = INITIAL_STATE.usedClientIds, action: LibraryAction): string[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.usedClientIds;
    default:
      return state;
  }
}
const clientBusinessTypesReducer = (state: ILookupItem[] = INITIAL_STATE.clientBusinessTypes, action: LibraryAction): ILookupItem[] => {
  switch (action.type) {
    case LOAD_LIBRARY_SUCCESS:
      return action.payload.lookupItems.clientBusinessTypes;
    default:
      return state;
  }
}
export const libraryReducer: Reducer<LibraryState> = combineReducers<LibraryState>({
  performanceItems: performanceItemsReducer,
  performanceItemCategories: performanceItemCategoriesReducer,
  performanceReportStatuses: performanceReportStatusesReducer,
  dpgClients: dpgClientsReducer,
  roles: rolesReducer,
  businessTypes: businessTypesReducer,
  usedClientIds: usedClientIdsReducer,
  clientBusinessTypes: clientBusinessTypesReducer,
});
